import {
  PIPE_ELEMENT_TYPE_BEND,
  PIPE_ELEMENT_TYPE_SINGLE_TEE,
  PIPE_ELEMENT_TYPE_DOUBLE_TEE,
  PIPE_ELEMENT_TYPE_TRIPLE_TEE,
  PIPE_ELEMENT_TYPE_STICK,
  PIPE_POSITION_LEFT,
  PIPE_POSITION_CENTER,
  PIPE_POSITION_RIGHT,
  PIPE_SIDE_TOP,
  PIPE_SIDE_SIDE,
  PIPE_SIDE_LEFT,
  PIPE_SIDE_RIGHT
} from "./types";

export default class PipeElement{
  constructor(
    id,
    type,
    placeholders
  ){
    /* set the id and type */
    this.id = id;
    this.type = type;
    /* check if restore or initialize accessory*/
    if(placeholders){
      this.placeholders = JSON.parse(JSON.stringify(placeholders));
    }else{
      this._initPlaceHoldersStructure();
    }
  }
  _initPlaceHoldersStructure(){
    switch(this.type){
      case PIPE_ELEMENT_TYPE_TRIPLE_TEE:
        this.placeholders = {
          [PIPE_POSITION_LEFT]: {
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_SIDE]:null,
          },
          [PIPE_POSITION_CENTER]: {
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_SIDE]: null
          },
          [PIPE_POSITION_RIGHT]: {
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_SIDE]:null
          }
        }
        break;
      case PIPE_ELEMENT_TYPE_DOUBLE_TEE:
        this.placeholders = {
          [PIPE_POSITION_LEFT]: {
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_SIDE]:null,
          },
          [PIPE_POSITION_RIGHT]: {
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_SIDE]:null
          }
        }
        break;
      case PIPE_ELEMENT_TYPE_SINGLE_TEE:
          this.placeholders = {
            [PIPE_POSITION_CENTER]: {
              [PIPE_SIDE_TOP]:null,
              [PIPE_SIDE_SIDE]: null
            }
          }
          break;
      case PIPE_ELEMENT_TYPE_STICK:
        this.placeholders = {
          [PIPE_POSITION_CENTER]: {
            [PIPE_SIDE_LEFT]: null,
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_RIGHT]: null
          }
        }
        break;
      case PIPE_ELEMENT_TYPE_BEND:
        this.placeholders = {
          [PIPE_POSITION_CENTER]: {
            [PIPE_SIDE_LEFT]: null,
            [PIPE_SIDE_TOP]:null,
            [PIPE_SIDE_RIGHT]: null
          },
        }
        break;
      default: break;
    }
  }
  clone(){
    return new PipeElement(
      this.id,
      this.type,
      this.placeholders
    );
  }
  attachAccessory(position, placement, type, size){
    if(!this.placeholders.hasOwnProperty(position)
    || !this.placeholders[position].hasOwnProperty(placement)){
      throw new Error(`Pipe element does not contain positioning: ${position}, or placement: ${placement}`, JSON.stringify(this.placeholders));
    }
    /* set the accessory */
    this.placeholders[position][placement] = {
      type,
      size
    };
  }
  detachAccessory(position, placement){
    if(!this.placeholders.hasOwnProperty(position)
    || !this.placeholders[position].hasOwnProperty(placement)){
      throw new Error(`Pipe element does not contain positioning: ${position}, or placement: ${placement}`);
    }
    /* set the accessory */
    this.placeholders[position][placement] = null;
  }
}



// WEBPACK FOOTER //
// ./src/lib/pipe-element.js